import React from 'react'
import { WpCategoriesNode } from './news/News'
import Tag from './Tag'

type Props = {
  categories: WpCategoriesNode
}

export default ({ categories }: Props) => {
  return (
    <div className="tags-container u-mb-lg">
      {categories.nodes.map(({ databaseId, name }: any) => (
        <Tag
          key={databaseId}
          value={databaseId}
          selectable={false}
          text={name}
        />
      ))}
    </div>
  )
}
